import axios from 'axios'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { EntityIdentifiersRequest, EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'
import { ConfigurationBillableConceptGroupCreateRequest, ConfigurationBillableConceptGroupPatchInBatchRequest, ConfigurationBillableConceptGroupResponse } from '@/modules/configurationModule/detail/accounting/billable/groups-of-concepts/services/configuration-billable-concept-group.dto'
import { ConfigurationBillableConceptResponse } from '@/modules/configurationModule/detail/accounting/billable/concepts/services/configuration-billable-concept.dto'
import { PAGINATOR_BIG_PAGE_SIZE } from '@/shared/services/services-constants'

class ConfigurationBillableConceptGroupService {
    async create(request: ConfigurationBillableConceptGroupCreateRequest): Promise<ConfigurationBillableConceptGroupResponse> {
        const response = await axios.post<ConfigurationBillableConceptGroupResponse>(`/configuration/billableConceptGroups`, request)
        return response.data
    }

    async paginator(filterModel: CommonFilterModel | undefined, params: CommonParams | undefined): Promise<IResponseAgGrid<ConfigurationBillableConceptGroupResponse>> {
        const response = await axios.put<IResponseAgGrid<ConfigurationBillableConceptGroupResponse>>(`/configuration/billableConceptGroups`, { ...filterModel }, { params })
        return response.data
    }

    async get(billableConceptGroupId: number): Promise<ConfigurationBillableConceptGroupResponse> {
        const response = await axios.get<ConfigurationBillableConceptGroupResponse>(`/configuration/billableConceptGroups/${billableConceptGroupId}`)
        return response.data
    }

    async delete(request: EntityIdentifiersRequest): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.delete<EntityIdentifierWithErrorResponse[]>(`/configuration/billableConceptGroups/batch`, { data: request })
        return response.data
    }

    async patch(request: ConfigurationBillableConceptGroupPatchInBatchRequest[]): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.patch<EntityIdentifierWithErrorResponse[]>(`/configuration/billableConceptGroups/batch`, request)
        return response.data
    }

    async findConceptsOfGroup(billableConceptGroupId: number): Promise<IResponseAgGrid<ConfigurationBillableConceptResponse>> {
        const filterModel: CommonFilterModel = {
            'group.id': {
                filterType: 'number',
                type: 'equals',
                filter: billableConceptGroupId
            }
        }
        const params: CommonParams = {
            size: PAGINATOR_BIG_PAGE_SIZE
        }
        const response = await axios.put<IResponseAgGrid<ConfigurationBillableConceptResponse>>(`/configuration/billableConcepts`, { ...filterModel }, { params })
        return response.data
    }
}

export const configurationBillableConceptGroupService = new ConfigurationBillableConceptGroupService()
